import { NotificationType } from "../models/enums/notification-type";

export const StackableNotificationTypes = [
    NotificationType.UnreadMessages,
    NotificationType.CustomerRequiresAttention,
    NotificationType.CustomerRequiresQuote
];